<template>
  <button class="logged_in_navigation" @mouseenter.stop="openProfile">
    <div class="avatar_container">
      <img :src="avatar" alt="user_avatar" class="user_avatar" />
      <div class="unread_count bold-s font-family-1" v-if="unread_count > 0">
        {{ unread_count }}
      </div>
    </div>
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.7097 11C12.2132 11 11 12.2132 11 13.7097C11 15.2062 12.2132 16.4194 13.7097 16.4194C15.2062 16.4194 16.4194 15.2062 16.4194 13.7097C16.4194 12.2132 15.2062 11 13.7097 11ZM13.7097 19.5806C12.2132 19.5806 11 20.7937 11 22.2903C11 23.7868 12.2132 24.9999 13.7097 24.9999C15.2062 24.9999 16.4194 23.7868 16.4194 22.2903C16.4194 20.7937 15.2062 19.5806 13.7097 19.5806ZM19.5806 13.7098C19.5806 12.2133 20.7938 11.0001 22.2903 11.0001C23.7868 11.0001 25 12.2133 25 13.7098C25 15.2063 23.7868 16.4195 22.2903 16.4195C20.7938 16.4195 19.5806 15.2063 19.5806 13.7098ZM22.2903 19.5806C20.7938 19.5806 19.5806 20.7937 19.5806 22.2903C19.5806 23.7868 20.7938 24.9999 22.2903 24.9999C23.7868 24.9999 25 23.7868 25 22.2903C25 20.7937 23.7868 19.5806 22.2903 19.5806Z"
        fill="white"
      />
    </svg>
  </button>
</template>

<script setup>
const user = useUserStore();
const { getLocale } = useFunctions();
const { public: publicConfig } = useRuntimeConfig();

defineProps({
  toggleProfile: {
    default: () => {},
  },
  openProfile: {
    default: () => {},
  },
});

const avatar = computed(() => {
  if (!user.getUser?.avatar) return "";
  if (
    user?.getUser?.avatar?.includes("http") ||
    user?.getUser?.avatar?.includes("https")
  ) {
    return user.getUser?.avatar;
  }
  if (user.getUser?.avatar?.includes("user-profile-images")) {
    return `${publicConfig.apiBaseUrl}${user.getUser?.avatar}`;
  }
  return user.getUser?.avatar;
});
const unread_count = computed(() => {
  return user.getUnreadMessage + user.getUnreadNotifications;
});

const fetchUnreadNotifications = async () => {
  try {
    const { data } = await useApiPost("/api/get-my-notifications-unread", {
      method: "POST",
      body: {
        locale: getLocale(),
      },
    });
    if (data?.unread_count >= 0) {
      user.setUnreadnotifications(data?.unread_count);
    }
  } catch (error) {
    console.log(error);
  }
};

const fetchUnreadMessages = async () => {
  try {
    const { data } = await useApiPost("/api/get-unread-chats", {
      method: "POST",
      body: {
        locale: getLocale(),
      },
    });
    if (data?.count_of_unread >= 0) {
      user.setUnreadMessages(data?.count_of_unread);
    }
  } catch (error) {
    //  console.log(error);
  }
};

await fetchUnreadNotifications();
await fetchUnreadMessages();

const pusherNotifications = async () => {
  window.Echo.private("notification." + user.getUser.id).listen(
    ".fetch.new",
    (e) => {
      console.log("FETCH");
      fetchUnreadNotifications();
    }
  );
};

const pusherChats = async () => {
  window.Echo.private("chats." + user.getUser.id).listen(".fetch.new", (e) => {
    console.log("FETCH MESSAGE");
    fetchUnreadMessages();
  });
};

onMounted(() => {
  pusherNotifications();
  pusherChats();
});

onBeforeUnmount(() => {
  console.log("UNMOUNT");
  if (user.getUser.id) {
    window.Echo.leave("notification." + user.getUser.id);
    window.Echo.leave("chats." + user.getUser.id);
  }
});
</script>
